import { getPageRouteFromPathname, stripDarkFromRoute, getProcessEnv, getDocumentLocation } from '@nike/ux-tread-dotcom-utils';
import { EVENTS_API_DIVISION, EVENTS_API_PLATFORM, EVENTS_API_VIEW_NAME } from './constants';
var defaultParams = {
  version: '1.0.0'
};

/**
 *
 */
export default function getAppInfo() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultParams,
    version = _ref.version;
  var _getProcessEnv = getProcessEnv(),
    NODE_ENV = _getProcessEnv.NODE_ENV;
  var _getDocumentLocation = getDocumentLocation(),
    host = _getDocumentLocation.host,
    pathname = _getDocumentLocation.pathname;
  var viewChannel = stripDarkFromRoute(getPageRouteFromPathname(pathname));
  return {
    name: viewChannel,
    environment: NODE_ENV,
    domain: host,
    division: EVENTS_API_DIVISION,
    platform: EVENTS_API_PLATFORM,
    version: version,
    viewChannel: viewChannel,
    viewName: EVENTS_API_VIEW_NAME
  };
}